/** @internal */
export const Placeholder = Object.freeze({
  host: '11.22.33.44'
});
